// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/.pnpm/css-loader@6.11.0_webpack@5.105.1_esbuild@0.28.1_/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.RelatedTerritoriesView-wrapper .filtersSection {
  margin-bottom: 24px;
}
.RelatedTerritoriesView-wrapper .countSection {
  margin: 24px 0px;
  min-height: 30px;
}
.RelatedTerritoriesView-wrapper .toggleViewButton {
  width: 100%;
  padding: 14px;
  display: flex;
  cursor: pointer;
  justify-content: center;
  align-items: center;
  background-color: var(--color_neutral_100);
  border-radius: 8px;
  color: var(--color_neutral_800);
  font-size: 14px;
  font-weight: 400;
}
.RelatedTerritoriesView-wrapper .toggleViewButton:hover {
  background-color: var(--color_primary_100);
  color: var(--color_primary_500);
}`, "",{"version":3,"sources":["webpack://./src/pages/SearchTerritoriesPage/components/WinninTopicsTab/components/RelatedTerritoriesView/index.scss"],"names":[],"mappings":"AACE;EACE,mBAAA;AAAJ;AAGE;EACE,gBAAA;EACA,gBAAA;AADJ;AAIE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,eAAA;EACA,uBAAA;EACA,mBAAA;EACA,0CAAA;EACA,kBAAA;EACA,+BAAA;EACA,eAAA;EACA,gBAAA;AAFJ;AAII;EACE,0CAAA;EACA,+BAAA;AAFN","sourcesContent":[".RelatedTerritoriesView-wrapper {\n  .filtersSection {\n    margin-bottom: 24px;\n  }\n\n  .countSection {\n    margin: 24px 0px;\n    min-height: 30px;\n  }\n\n  .toggleViewButton {\n    width: 100%;\n    padding: 14px;\n    display: flex;\n    cursor: pointer;\n    justify-content: center;\n    align-items: center;\n    background-color: var(--color_neutral_100);\n    border-radius: 8px;\n    color: var(--color_neutral_800);\n    font-size: 14px;\n    font-weight: 400;\n\n    &:hover {\n      background-color: var(--color_primary_100);\n      color: var(--color_primary_500);\n    }\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
